import React, { useState, useEffect } from 'react';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from './../MainCalculators';
const TITLE = 'Test Grade Calculator - Exam Grade Calculator';
const DESCRIPTION = 'Easily calculate your test score and grade using the advanced grade calculator. Get the percentage and letter grade based on the number of points and incorrect answers.';
const KEYWORDS = 'grade calculator, grade percentage calculator, test grade calculator, percentage calculator, grade estimation, test grade calculator, exam grade calculator, grade calculation tool';
const OG_URL = 'https://do-calculate.com/calculator/en/test-grade';
function GradeCalculator() {
    const [points, setPoints] = useState('');
    const [wrong, setWrong] = useState('');
    const [correct, setCorrect] = useState('');
    const [percentage, setPercentage] = useState('');
    const [grade, setGrade] = useState('');
    useEffect(() => {
        const pointsValue = parseFloat(points) || 0;
        const wrongValue = parseFloat(wrong) || 0;
        const correctValue = parseFloat(correct) || 0;
        if (pointsValue > 0) {
            if (wrong !== '' && correct === '') {
                const calculatedCorrect = pointsValue - wrongValue;
                setCorrect(calculatedCorrect >= 0 ? calculatedCorrect.toString() : '');
            } else if (correct !== '' && wrong === '') {
                const calculatedWrong = pointsValue - correctValue;
                setWrong(calculatedWrong >= 0 ? calculatedWrong.toString() : '');
            }
            const finalCorrect = wrong !== '' ? pointsValue - wrongValue : correctValue;
            if (finalCorrect >= 0 && finalCorrect <= pointsValue) {
                const percentageValue = (finalCorrect / pointsValue) * 100;
                setPercentage(Math.round(percentageValue * 100) / 100);
                let gradeValue = '';
                if (percentageValue >= 90) {
                    gradeValue = 'A';
                } else if (percentageValue >= 80) {
                    gradeValue = 'B';
                } else if (percentageValue >= 70) {
                    gradeValue = 'C';
                } else if (percentageValue >= 60) {
                    gradeValue = 'D';
                } else {
                    gradeValue = 'F';
                }
                setGrade(gradeValue);
            } else {
                setCorrect('');
                setPercentage('');
                setGrade('');
            }
        }
    }, [points, wrong, correct]);
    const handlePointsChange = (e) => setPoints(e.target.value);
    const handleWrongChange = (e) => {
        setWrong(e.target.value);
        if (points !== '') {
            setCorrect((parseFloat(points) - parseFloat(e.target.value)).toString());
        }
    };
    const handleCorrectChange = (e) => {
        setCorrect(e.target.value);
        if (points !== '') {
            setWrong((parseFloat(points) - parseFloat(e.target.value)).toString());
        }
    };
    return (
        <div>
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                    <p>
                        This test grade calculator is an indispensable tool if you're looking for a tool to help determine grade scales. Also known as the test grade calculator or teacher estimation tool, this tool allows you to quickly find the grade and percentage based on the number of points and incorrect answers (or correct ones). Additionally, you can change the default grade scale and set your own scale. Still wondering how to calculate test grades? Scroll down to learn more – or simply try this grade scale calculator.
                    </p>
                    <MobileUnderCalAds/>
                    <div className="border border-light p-3">
                        <div className="row">
                          <div className="col-sm-12 col-md-7 calculatorStyle">
                                <div className="p-3 mb-2 bg-success text-white">
                                    <h2 style={{ fontSize: '16px' }}>{TITLE}</h2>
                                </div>
                                <hr />
                                <div>
                                    <div className="form-group d-flex align-items-center mb-2">
                                        <b>
                                            <label className="form-label ms-2" htmlFor="pointsInput">Points / Questions ❔</label>
                                        </b>
                                        <input
                                            id="pointsInput"
                                            type="number"
                                            placeholder="Number of points"
                                            value={points}
                                            onChange={handlePointsChange}
                                            className="form-control"
                                            style={{ width: '200px' }}
                                        />
                                    </div>
                                    <div className="form-group d-flex align-items-center mb-2">
                                        <b>
                                            <label className="form-label ms-2" htmlFor="wrongInput">Wrong Questions ❌</label>
                                        </b>
                                        <input
                                            id="wrongInput"
                                            type="number"
                                            placeholder="Number of wrong questions"
                                            value={wrong}
                                            onChange={handleWrongChange}
                                            className="form-control"
                                            style={{ width: '200px' }}
                                        />
                                    </div>
                                    <div className="form-group d-flex align-items-center mb-2">
                                        <b>
                                            <label className="form-label ms-2" htmlFor="correctInput">Correct Questions ✔️</label>
                                        </b>
                                        <input
                                            id="correctInput"
                                            type="number"
                                            placeholder="Number of correct questions"
                                            value={correct}
                                            onChange={handleCorrectChange}
                                            className="form-control"
                                            style={{ width: '200px' }}
                                        />
                                    </div>
                                    <br />
                                    <div className="form-group d-flex align-items-center mb-2">
                                        <b>
                                            <label className="form-label ms-2" htmlFor="percentageInput">Percentage %</label>
                                        </b>
                                        <input
                                            id="percentageInput"
                                            type="text"
                                            placeholder="Percentage"
                                            value={percentage}
                                            readOnly
                                            className="form-control"
                                            style={{ width: '150px' }}
                                        />
                                    </div>
                                    <div className="form-group d-flex align-items-center mb-2">
                                        <b>
                                            <label className="form-label ms-2" htmlFor="gradeInput">Grade</label>
                                        </b>
                                        <input
                                            id="gradeInput"
                                            type="text"
                                            placeholder="Grade"
                                            value={grade}
                                            readOnly
                                            className="form-control"
                                            style={{ width: '150px' }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: "auto" }}>
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">{TITLE} </div>
                            <div className="info-section-body">
                                <div>
                                    <u>
                                        <h2 style={{ fontSize: "16px" }}>How to Calculate Test Grades</h2>
                                    </u>
                                    <p>
                                        To calculate the percentage of the test grade, all you need to do is divide the earned points by the total possible points. In other words, you simply find the percentage of correct answers:
                                    </p>
                                    <p>
                                        <b>Grade Percentage = (Number of Correct Answers / Total Number of Questions) × 100</b>
                                    </p>
                                    <p>
                                        Since the number of correct answers + the number of incorrect answers = the total number of questions, we can write the equation as follows:
                                    </p>
                                    <p>
                                        <b>Grade Percentage = 100 × (Total Number of Questions - Number of Incorrect Answers) / Total Number of Questions</b>
                                    </p>
                                    <p>
                                        After that, all you have to do is convert the percentage to a letter grade. The default grade scale is shown in the table below:
                                    </p>
                                    <table >
                                        <thead>
                                            <tr>
                                                <th >Letter Grade</th>
                                                <th >Percentage</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>A+</td>
                                                <td>97-100</td>
                                            </tr>
                                            <tr>
                                                <td>A</td>
                                                <td>93-96</td>
                                            </tr>
                                            <tr>
                                                <td>A-</td>
                                                <td>90-92</td>
                                            </tr>
                                            <tr>
                                                <td>B+</td>
                                                <td>87-89</td>
                                            </tr>
                                            <tr>
                                                <td>B</td>
                                                <td>83-86</td>
                                            </tr>
                                            <tr>
                                                <td>B-</td>
                                                <td>80-82</td>
                                            </tr>
                                            <tr>
                                                <td>C+</td>
                                                <td>77-79</td>
                                            </tr>
                                            <tr>
                                                <td>C</td>
                                                <td>73-76</td>
                                            </tr>
                                            <tr>
                                                <td>C-</td>
                                                <td>70-72</td>
                                            </tr>
                                            <tr>
                                                <td>D+</td>
                                                <td>67-69</td>
                                            </tr>
                                            <tr>
                                                <td>D</td>
                                                <td>63-66</td>
                                            </tr>
                                            <tr>
                                                <td>D-</td>
                                                <td>60-62</td>
                                            </tr>
                                            <tr>
                                                <td>F</td>
                                                <td>Less than 60</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p>
                                        If you don't prefer using grades with pluses or minuses, the scale might look like this:
                                    </p>
                                    <ul>
                                        <li>A from 90% to 100%</li>
                                        <li>B from 80% to 89%</li>
                                        <li>C from 70% to 79%</li>
                                        <li>D from 60% to 69%</li>
                                        <li>F from 59% and below – which is not a passing grade</li>
                                    </ul>
                                    <p>
                                        Above, you can find the standard grading system for American schools and universities. However, grades may vary between schools, classes, and teachers. Always check in advance the system used in your case.
                                    </p>
                                    <p>
                                        Sometimes the boundaries for a passing grade aren't 60%, but for example, 50% or 65%. What next? We've got it covered – you can change the ranges for each grade! Read more about it in the final section of this article: Advanced Options.
                                    </p>
                                    <p>
                                        You might also be interested in the semester grade calculator and the final grade calculator.
                                    </p>
                                    <h2 style={{ fontSize: "16px" }}>Test Grade Calculator – How to Use It?</h2>
                                    <p>
                                        Our test grade calculator is a simple and easy-to-use tool!
                                    </p>
                                    <p>
                                        Enter the number of questions/points/problems in the student's work (test, exam, anything). Suppose you prepared a test with 18 questions.
                                    </p>
                                    <p>
                                        Enter the number of questions the student answered incorrectly. Alternatively – if you prefer – you can enter the number of points earned. Let's assume our model student got three questions wrong.
                                    </p>
                                    <p>
                                        Here we go! The teacher's estimation tool shows the percentage and grade for this exam. In our example, the student scored 83.33% on the test, which corresponds to a B grade.
                                    </p>
                                    <p>
                                        Below, you'll find the full grade scale table. So, to check the next student's grade, you can write the number of questions they answered incorrectly – or simply use this nice table.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default GradeCalculator;
